import CheckboxChecked20 from '@carbon/icons-react/es/checkbox--checked/20';
import ListBulleted20 from '@carbon/icons-react/es/list--bulleted/20';
import ListNumbered20 from '@carbon/icons-react/es/list--numbered/20';
import React, { FC } from 'react';
import { useDocuments } from 'components/organisms/document/document-store';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { ToolItem } from '../../styled-components';

export enum ListToolTypes {
  Numbered = 'numberedList',
  Bulleted = 'bulletedList',
  Checked = 'todoList',
}

interface ListToolProps {
  icon: React.ReactNode;
  type: string;
}
const ListTool: FC<ListToolProps> = ({ icon, type }) => {
  const [state] = useDocuments();

  const executes = () => {
    state.editor.execute(type);
    state.editor.editing.view.focus();
  };

  return (
    <ToolItem onClick={() => executes()}>
      {icon}
      {useTranslation(`toolbar.${type}` as TranslationKey)}
    </ToolItem>
  );
};

export const AddListNumbered: FC = () => {
  return <ListTool icon={<ListNumbered20 />} type={ListToolTypes.Numbered} />;
};

export const AddListBulleted: FC = () => {
  return <ListTool icon={<ListBulleted20 />} type={ListToolTypes.Bulleted} />;
};

export const CheckList: FC = () => {
  return <ListTool icon={<CheckboxChecked20 />} type={ListToolTypes.Checked} />;
};
